import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';

import { AngularMaterialModule } from '@cradua/material';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LoginPageComponent } from '../lib/containers';
import {
  LoginFormComponent,
  LogoutConfirmationDialogComponent,
} from '../lib/components';

import { AuthEffects } from '../lib/effects';
import * as fromAuth from '../lib/reducers';
import {AuthFacade} from '../lib/facades/auth.facade'

import { AuthorizedGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { TokenInterceptor } from './token.interceptor';
import { ManageComponent } from './components/manage/manage.component';
import { SubscribeComponent } from './components/subscribe/subscribe.component';
import { ApplicationContainerComponent } from './containers/application-container/application-container.component';
import { ApplicationComponent } from './components/application/application.component';
import { AddminApplicationComponent } from './components/addmin-application/addmin-application.component';
import { AddminApplicationContainerComponent } from './containers/addmin-application-container/addmin-application-container.component';
import {SpinnersModule} from "@cradua/spinners";
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';




export const COMPONENTS = [
  LoginPageComponent,
  LoginFormComponent,
  LogoutConfirmationDialogComponent,
  ManageComponent,
  SubscribeComponent,
  ApplicationContainerComponent,
  ApplicationComponent,
  AddminApplicationComponent,
  AddminApplicationContainerComponent,
  ChangepasswordComponent
];


export const authRoutes: Route[] = [{ path: 'login', component: LoginPageComponent, data: { title: 'Login'} },
{ path: 'login/:id', component: LoginPageComponent, data: { title: 'Login' } },
{ path: 'manage/:id/:token', component: ManageComponent, data: { title: 'Manage' } },
{ path: 'manage', component: ManageComponent, data: { title: 'Manage' } },
{ path: 'subscribe', component: SubscribeComponent, data: { title: 'Subscribe' } },
{path: 'application', component: ApplicationContainerComponent, data: {title: 'Application'}},
{path: 'addminapplication', component: AddminApplicationContainerComponent, data: {title: 'Addmapplication'}},
{path: 'changepassword', component: ChangepasswordComponent, data: {title: 'Change Password'}},

];

@NgModule({
  imports: [
   CommonModule, RouterModule.forChild(authRoutes), HttpClientModule,AngularMaterialModule,FormsModule,
   SpinnersModule, ReactiveFormsModule,StoreModule.forFeature(fromAuth.authFeatureKey, fromAuth.reducers),
    EffectsModule.forFeature([AuthEffects]),],

    declarations: COMPONENTS,
    entryComponents: [LogoutConfirmationDialogComponent],
    providers: [ AuthFacade ,
              AuthorizedGuard,
                AuthService,


                {
                  provide: HTTP_INTERCEPTORS,
                  useClass: TokenInterceptor,
                  multi: true
                }
              ],
})
export class AuthModule {}
